import type mapboxgl from 'mapbox-gl';

/**
 * True when the map still has a live style, i.e. it is safe to call
 * `getLayer` / `removeLayer` / `getSource` / `setLayoutProperty` on it.
 *
 * Why this exists: when a page that hosts UnifiedAirportMap unmounts (e.g.
 * navigating away from ProjectDetailPage), the Mapbox map can already be
 * torn down (`map.remove()` clears its internal style) by the time a child
 * layer's cleanup effect runs. Calling `map.getLayer(...)` then throws
 * "Cannot read properties of undefined (reading 'getLayer')" from inside a
 * React passive-effect unmount, which tears down the whole React tree and
 * leaves a black screen. `getStyle()` is safe post-remove (it returns
 * undefined instead of throwing), so it is the right liveness probe.
 */
export function isMapAlive(map?: mapboxgl.Map | null): boolean {
  try {
    return !!map && typeof map.getStyle === 'function' && !!map.getStyle();
  } catch {
    return false;
  }
}
